import { homApi } from '~/redux/apis/hom'
import { Preference } from '~/types/tutoring-api'
import { transformPreference } from '~/utils'

export const preferenceApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreference: builder.query<Preference<''> | undefined, void>({
      query: () => '/v1/preferences',
      transformResponse(response: Preference<'from-api-response'>) {
        if (!response) return

        return transformPreference(response)
      },
    }),
  }),
})

export const { useGetPreferenceQuery } = preferenceApi
